var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22207 4.074C2.11981 4.074 2.03689 4.15691 2.03689 4.25919V16.111C2.03689 16.2133 2.11981 16.2962 2.22207 16.2962H15.5554C15.6577 16.2962 15.7406 16.2133 15.7406 16.111V4.25919C15.7406 4.15691 15.6577 4.074 15.5554 4.074H2.22207ZM0.925781 4.25919C0.925781 3.54327 1.50615 2.96289 2.22207 2.96289H15.5554C16.2713 2.96289 16.8517 3.54327 16.8517 4.25919V16.111C16.8517 16.827 16.2713 17.4073 15.5554 17.4073H2.22207C1.50615 17.4073 0.925781 16.827 0.925781 16.111V4.25919Z",
    fill: "#1A9D39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.925781 7.96278C0.925781 7.65596 1.17452 7.40723 1.48134 7.40723H16.2961C16.603 7.40723 16.8517 7.65596 16.8517 7.96278C16.8517 8.26962 16.603 8.51834 16.2961 8.51834H1.48134C1.17452 8.51834 0.925781 8.26962 0.925781 7.96278Z",
    fill: "#1A9D39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.925781 12.4071C0.925781 12.1003 1.17452 11.8516 1.48134 11.8516H16.2961C16.603 11.8516 16.8517 12.1003 16.8517 12.4071C16.8517 12.7139 16.603 12.9627 16.2961 12.9627H1.48134C1.17452 12.9627 0.925781 12.7139 0.925781 12.4071Z",
    fill: "#1A9D39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29579 1.48145C6.60261 1.48145 6.85135 1.73017 6.85135 2.037V4.99996C6.85135 5.30679 6.60261 5.55551 6.29579 5.55551C5.98897 5.55551 5.74023 5.30679 5.74023 4.99996V2.037C5.74023 1.73017 5.98897 1.48145 6.29579 1.48145Z",
    fill: "#1A9D39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4813 1.48145C11.7882 1.48145 12.0369 1.73017 12.0369 2.037V4.99996C12.0369 5.30679 11.7882 5.55551 11.4813 5.55551C11.1745 5.55551 10.9258 5.30679 10.9258 4.99996V2.037C10.9258 1.73017 11.1745 1.48145 11.4813 1.48145Z",
    fill: "#1A9D39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29579 7.40723C6.60261 7.40723 6.85135 7.65596 6.85135 7.96278V16.8517C6.85135 17.1584 6.60261 17.4072 6.29579 17.4072C5.98897 17.4072 5.74023 17.1584 5.74023 16.8517V7.96278C5.74023 7.65596 5.98897 7.40723 6.29579 7.40723Z",
    fill: "#1A9D39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4813 7.40723C11.7882 7.40723 12.0369 7.65596 12.0369 7.96278V16.8517C12.0369 17.1584 11.7882 17.4072 11.4813 17.4072C11.1745 17.4072 10.9258 17.1584 10.9258 16.8517V7.96278C10.9258 7.65596 11.1745 7.40723 11.4813 7.40723Z",
    fill: "#1A9D39"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2958 4.81543C16.6026 4.81543 16.8513 5.06415 16.8513 5.37099V15.0007C16.8513 15.3074 16.6026 15.5562 16.2958 15.5562C15.9889 15.5562 15.7402 15.3074 15.7402 15.0007V5.37099C15.7402 5.06415 15.9889 4.81543 16.2958 4.81543Z",
    fill: "#1A9D39"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48134 4.81543C1.78816 4.81543 2.03689 5.06415 2.03689 5.37099V15.0007C2.03689 15.3074 1.78816 15.5562 1.48134 15.5562C1.17452 15.5562 0.925781 15.3074 0.925781 15.0007V5.37099C0.925781 5.06415 1.17452 4.81543 1.48134 4.81543Z",
    fill: "#1A9D39"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63086 16.8515C4.63086 16.5447 4.87959 16.2959 5.18642 16.2959H12.5939C12.9007 16.2959 13.1494 16.5447 13.1494 16.8515C13.1494 17.1582 12.9007 17.407 12.5939 17.407H5.18642C4.87959 17.407 4.63086 17.1582 4.63086 16.8515Z",
    fill: "#1A9D39"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4438 15.0002C19.4438 12.8524 17.7027 11.1113 15.5549 11.1113C13.4071 11.1113 11.666 12.8524 11.666 15.0002C11.666 17.148 13.4071 18.8891 15.5549 18.8891C17.7027 18.8891 19.4438 17.148 19.4438 15.0002Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.64 12.7109C15.9066 12.7112 16.1109 12.9569 16.1104 13.072V16.6665C16.1101 16.7815 15.8936 17.0167 15.6269 17.0165C15.3601 17.0164 15.1442 16.7815 15.1445 16.6665V13.072C15.1449 12.9569 15.3732 12.7108 15.64 12.7109Z",
    fill: "#1A9D39"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5645 14.9221C13.5645 14.6582 13.7741 14.4443 13.8891 14.4443H17.5366C17.6516 14.4443 17.87 14.6582 17.87 14.9221C17.87 15.186 17.6516 15.3999 17.5366 15.3999H13.8891C13.7741 15.3999 13.5645 15.186 13.5645 14.9221Z",
    fill: "#1A9D39"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4438 15.0002C19.4438 12.8524 17.7027 11.1113 15.5549 11.1113C13.4071 11.1113 11.666 12.8524 11.666 15.0002C11.666 17.148 13.4071 18.8891 15.5549 18.8891C17.7027 18.8891 19.4438 17.148 19.4438 15.0002Z",
    stroke: "#1A9D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCalendar);
export default __webpack_public_path__ + "static/media/green-calendar.fc3542b30d9ceb196f058be1eb136499.svg";
export { ForwardRef as ReactComponent };